<template>
  <transition name="confirm-fade">
    <div v-if="isShowConfirm" class="my-confirm" @click.stop="clickFun('clickCancel')">
      <div :class="['wrap', { 'container-dark': theme_dark }]" @click.stop>
        <h3 class="title">{{ titleText }}</h3>
        <div class="content">
          <div class="ub ub-ver">
            <div class="info-block">
              <div class="ub ub-pc info-item">
                <img src="../assets/img/手机.png">
                <input type="text" v-model="tel" placeholder="请输入绑定的手机号码">
              </div>
              <div class="ub">
                <div class="ub ub-pc ub-f1 info-item">
                  <img src="../assets/img/图形验证码.png">
                  <input type="text" v-model="img_code" placeholder="图形验证码" class="input-verify">
                </div>
                <img :src="img_code_url" class="verify-img" @click="change_imgcode()">
              </div>

              <div class="ub">
                <div class="ub ub-pc ub-f1 info-item">
                  <img src="../assets/img/数字验证码.png">
                  <input type="text" v-model="msg_code" placeholder="手机验证码" class="input-verify">
                </div>
                <div class="obtain-btn ub ub-pc ub-ac" @click="onObtain()"><span>{{time_sub}}</span></div>
              </div>
            </div>
          </div>
        </div>
        <div class="oper ub ub-ac3">
            <div v-if="type==='confirm'" class="cancel ub ub-ac" @click="clickFun('clickCancel')">
                <span>{{ cancelText }}</span>
            </div>
            <div class="ok ub ub-ac" @click="clickFun('clickConfirm')">
                <span>{{ confirmText }}</span>
            </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
  import { mapMutations, mapActions } from 'vuex';
  import * as tool from '../api/common';
  export default {
    data() {
      return {
        isShowConfirm: false, // 用于控制整个窗口的显示/隐藏
        titleText: "操作提示", // 提示框标题
        content: "Say Something ...", // 提示框的内容
        cancelText: "取消", // 取消按钮的文字
        confirmText: "确认", // 确认按钮的文字
        type: "confirm", // 表明弹框的类型：confirm - 确认弹窗（有取消按钮）；alert - 通知弹框（没有取消按钮）
        outerData: null, // 用于记录外部传进来的数据，也可以给外部监听userBehavior，事件的函数提供判断到底是哪个事件触发的

        img_code_url: '',
        time_sub: '获取',
        tel: '',
        img_code: '',
        msg_code: '',
        theme_dark: false
      };
    },
    methods: {
      ...mapMutations(['get', 'post']), //引入方法
      ...mapActions(["act_reload_userinfo", 'act_get_userinfo']), //引入方法

      show(content, config) {
        //切换深色模式
        this.theme_dark = tool.is_theme_dark(this);
        this.content = content || "Say Something ...";

        if (Object.prototype.toString.call(config) === "[object Object]") {
          // 确保用户传递的是一个对象
          this.titleText = config.titleText || "操作提示";
          this.cancelText = config.cancelText || "取消";
          this.confirmText = config.confirmText || "确认";
          this.type = config.type || "confirm";
          this.outerData = config.data || null;
        }

        this.isShowConfirm = true;

        this.init_page();
      },
      hidden() {
        this.isShowConfirm = false;
        this.titleText = "操作提示";
        this.cancelText = "取消";
        this.confirmText = "确认";
        this.type = "confirm";
        this.outerData = null;

        this.tel = '';
        this.img_code = '';
        this.msg_code = '';
      },
      clickFun(type) {
        if (type == 'clickConfirm') {
          var tel = this.tel;
          var img_code = this.img_code;
          //验证手机号码
          if (tel == '') {
            this.$toast.center('请输入手机号码');
            return false;
          }
          if (!tool.IsTelephone(tel)) {
            this.$toast.center('手机号码错误,请重新输入');
            return false;
          }

          //验证图形验证码
          if (img_code == '') {
            this.$toast.center('请输入图形验证码');
            return false;
          }

          //短信验证码验证
          var msg_code = this.msg_code;
          if (msg_code == '') {
            this.$toast.center('请输入短信验证码');
            return false;
          }
          var uid = this.$store.state.uid;
          this.check_msgcode( msg_code, uid);
        }
        else {
          this.hidden();
        }
        //this.$emit("formBehavior", type, this.outerData);
        //this.hidden();
      },

      init_page() {
        this.img_code_url = require('../assets/img/验证码图片.png');
        this.get_imgcode();
      },

      onObtain() {

        var tel = this.tel;
        var img_code = this.img_code;

        //点击验证
        if (this.time_sub != '获取') {
          return false;
        }

        //验证手机号码
        if (tel == '') {
          this.$toast.center('请输入手机号码');
          return false;
        }
        if (!tool.IsTelephone(tel)) {
          this.$toast.center('手机号码错误,请重新输入');
          return false;
        }

        //验证图形验证码
        if (img_code == '') {
          this.$toast.center('请输入图形验证码');
          return false;
        }

        var uid = this.$store.state.uid;

        this.check_imgcode(img_code, uid);

      },

      change_imgcode() {
        this.get_imgcode();
      },

      get_imgcode() {
        var self = this;
        var uid = self.$store.state.uid;
        self.get({
          url: '/Common/Create_Img_CheckCode/?uid=' + uid,
          success: function (serve_data) {
            if (serve_data.state == '1') {
              self.img_code_url = 'data:image/png;base64,' + serve_data.msg;
            }
          },
          error: function (err) {
            console.log(err);
          }
        });
      },

      check_imgcode(img_code, uid) {
        var self = this;
        self.time_sub = '..';
        self.get({
          url: '/Common/Check_Img_CheckCode2/?code=' + img_code + '&uid=' + uid,
          success: function (serve_data) {
            if (serve_data.state == '1') {
              //检测手机号码
              var tel = self.tel;
              self.check_tel(tel, uid);
              self.time_sub = '...';
            } else {
              self.time_sub = '获取';
              self.$toast.center(serve_data.msg);
              self.change_imgcode();
            }
          },
          error: function (err) {
            self.time_sub = '获取';
            console.log(err);
          }
        });
      },

      check_tel(tel, uid) {
        var self = this;
        self.time_sub = '..';
        self.get({
          url: '/App/Check_Tel/?tel=' + tel + '&uid=' + uid,
          success: function (serve_data) {
            if (serve_data.state == '1') {
              var uid_old = serve_data.msg;
              if (uid == uid_old) {
                self.$toast.center('您当前没走丢呢，无需找回哦');
                self.time_sub = '获取';
              }
              else {
                //发送短信验证码
                var img_code = self.img_code;
                self.get_msgcode(tel, img_code, uid);
              }
            }
            else {
              self.$toast.center('该手机号未绑定');
              self.time_sub = '获取';
            }
          },
          error: function (err) {
            self.time_sub = '获取';
            console.log(err);
          }
        });
      },

      get_msgcode(tel, img_code, uid) {
        var self = this;
        self.get({
          url: '/Common/SendVerifyCode/?phone=' + tel + '&img_code=' + img_code + '&uid=' + uid,
          success: function (serve_data) {
            if (serve_data.state == '1') {
              //发送成功,到计时开始
              self.set_time();
            }
            else {
              self.time_sub = '获取';
              self.$toast.center(serve_data.msg);
            }
          },
          error: function (err) {
            self.time_sub = '获取';
            console.log(err);
          }
        });
      },

      check_msgcode(msg_code, uid) {
        var self = this;
        self.get({
          url: '/Common/CheckMsgCode/?code=' + msg_code + '&uid=' + uid,
          success: function (serve_data) {
            if (serve_data.state == '1') {
              //验证成功，进行找回
              var tel = self.tel;
              self.find_old_account(tel, uid, msg_code);
            }
            else {
              self.$toast.center(serve_data.msg);
            }
          },
          error: function (err) {
            console.log(err);
          }
        });
      },

      find_old_account(tel, uid, msg_code) {

        var openid = this.$store.state.openid;
        if (!openid) {
          if ($cookies.isKey('openid')) {
            openid = $cookies.get('openid');
          }
        }
        //后台处理
        var self = this;
        self.get({
          url: '/App/Find_Account/?tel=' + tel + '&uid=' + uid + '&out_id=' + openid + '&msg_code=' + msg_code,
          success: function (data_serve) {
            if (data_serve.state == '1') {
              var uid_old = data_serve.msg;

              self.act_reload_userinfo({
                'uid': uid_old,
                success: function (u) {
                  self.$toast.center('找回成功,请退出重新进入即可');
                  self.hidden();
                  //更换当前保存的uid信息
                  $cookies.set('uid', uid_old, 30 * 24 * 60 * 60);
                  self.$store.commit('set_uid', uid_old);
                  //跳转到个人中心
                  //this.$router.push({ name: "my" });
                }
              })
            }
            else {
              self.$toast.center(data_serve.msg);
            }
          },
          error: function (err) {
            console.log(err);
          }
        });

      },

      set_time() {
        var start = 60;
        var self = this;
        var itv = setInterval(function () {
          self.time_sub = start-- + 's';
          if (start <= 0) {
            self.time_sub = '获取';
            clearInterval(itv);
          }
        }, 1000);
      }
    }
  };
</script>

<style lang="scss" scoped>
  .my-confirm {
    position: fixed;
    top: 0;
    left: 0;
    width:100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 998;
    /* 这里防止当用户长按屏幕，出现的黑色背景色块，以及 iPhone 横平时字体的缩放问题 */
    -webkit-text-size-adjust: 100%;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  }

  /* 进入和出去的动画 */
  .confirm-fade-enter-active {
    animation: opacity 0.3s;
  }

  .confirm-fade-leave-active {
    animation: outOpacity 0.2s;
  }

  /* 进来的动画 */
  @keyframes opacity {
    0% {
      opacity: 0;
    }

    100% {
      opacity: 1;
    }
  }

  /* 出去的动画 */
  @keyframes outOpacity {
    0% {
      opacity: 1;
    }

    100% {
      opacity: 0;
    }
  }

  /* 包裹层容器样式 */
  .wrap {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate3d(-50%, -50%, 0);
        width: 85%;
        margin: 0 auto;
        z-index: 999;
        user-select: none;
        border-radius: 1rem;
        background: linear-gradient(to bottom, #FE9CC0, #fff 3rem);
  }

  /* 顶部标题部分 */
  .title {
    height: 3rem;
    line-height: 3rem;
    text-align: center;
    font-size: 1rem;
    font-weight: bold;
    color: #6C1AAB;
  }

  /* 中间内容部分 */
  .content {
        line-height: 1.6rem;
        font-size: 0.9rem;
        color: #666;
        padding: 1.5rem 0.8rem 0 0.8rem;
        
  }
  .info-block {
          padding: 0.4rem;
          .info-item {
            padding: 0.2rem 0.8rem;
            border: 1px solid #9dcef7;
            height: 2rem;
            margin-bottom: 1rem;
            border-radius: 0.3rem;
            img {
              width: 1.5rem;
              height: 1.5rem;
            }
            input {
              background-color: transparent;
              margin-left: 0.8rem;
              border: 0;
              outline: 0;
              font-size: 1rem;
            }
            .input-verify {
              background-color: transparent;
              margin-left: 0.8rem;
              border: 0;
              outline: 0;
              font-size: 1rem;
              width: 6rem;
            }
          }
          .verify-img {
            height: 2rem;
            width: 4rem;
            margin: 0 0 0 1rem;
          }
          .obtain-btn {
            height: 2rem;
            width: 3.9rem;
            margin-left: 1rem;
            border: 1px solid;
            border-radius: 0.5rem;
            border-image: linear-gradient(180deg, rgba(138, 97, 255, 1), rgba(148, 231, 224, 1)) 1 1;
            span {
              font-size: 0.75rem;
              font-weight: bold;
              color: #A264E7;
            }
          }
        }

 /* 底部按钮样式 */
 .oper {
        padding-bottom: 1rem;
        .ok {
            margin: 0 0.5rem;
            flex: 1;
            border-radius: 2rem;
            background: linear-gradient( 90deg, #A264E7, #FE9CC0);
            
        }

        .cancel{
            margin: 0 0.5rem;
            flex: 1;
            color: #FFFFFF;
            background-color: #C1C1C1;
            border-radius: 2rem;
        }

        span {
            line-height: 2.6rem;
            color: #fff;
        }
    }

  .container-dark {
    background: linear-gradient(to bottom, #9c365c, #333 3rem);
    .title {
      color: #fff;
    }
    .info-block {
        .info-item {
            border: 1px solid #666;
            input {
            color: #999;
          }
        }
      }
  }
</style>